// Copyright 2016 Sorama B.V.

export class InvalidRouteView {}
